import * as React from 'react';
import { WHelpIcon } from '../core/elements/WHelpIcon';

export function getDefaultHelpIcon(key: string, title: string, data?: any, style?: React.CSSProperties, style2?: React.CSSProperties, style3?: React.CSSProperties, additionalWrapperClass?: string) {
    return (
        <WHelpIcon
            data={data}
            styleDivProps={{
                ...(style ? style : {}),
                display: 'inline-block', position: 'fixed', right: 40, marginTop: 10, zIndex: 100,
                ...(style3 ? style3 : {})
            }}
            styleProps={{
                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0,
                ...(style2 ? style2 : {})
            }}
            label={title}
            helpKey={key}
            editBar
            // type='info'
            style={'theme_small'}
            type={'theme_info'}
            customElement={'Info'}
            useTheme
            additionalWrapperClass={additionalWrapperClass}
        />
    );
}

export function getDefaultHelpIconDatei(key: string, title: string, data: any, additionalWrapperClass?: string) {
    return (
        <WHelpIcon
            data={data}
            styleDivProps={{ display: 'inline-block', position: 'fixed', right: 50, marginTop: 10, zIndex: 100 }}
            // styleDivProps={{ display: 'inline-block', position: 'fixed', right: 20, marginTop: 7, zIndex: 100 }}
            styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
            label={title}
            helpKey={key}
            helpDatei={key}
            editBar
            // type='info'
            style={'theme_small'}
            type={'theme_info'}
            customElement={'Info'}
            useTheme
            additionalWrapperClass={additionalWrapperClass}
        />
    );
}
